import findIndex from 'lodash/findIndex';
import { ESTIMATION_FIELD_ID_ORIGINAL_ESTIMATE } from '@atlassian/jira-software-report-charting-common/src/common/constants.tsx';
import {
	ESTIMATION_STORY_POINTS,
	ESTIMATION_ISSUE_COUNT,
	ESTIMATION_ORIGINAL_ESTIMATE,
} from '@atlassian/jira-software-report-charting-common/src/common/utils/format-estimate/index.tsx';
import type { Sprint, SprintReportsEstimationStatistic } from '../../types';

export const getSprintFilterRank = (sprints: Sprint[] | null, sprintId: string | number | null) => {
	if (sprints && sprintId !== null) {
		return findIndex(sprints, { id: sprintId }) + 1;
	}
	return null;
};

export const getCurrentEstimationStatistic = (
	customFieldId: string | null,
): SprintReportsEstimationStatistic => {
	if (customFieldId === ESTIMATION_FIELD_ID_ORIGINAL_ESTIMATE) {
		return ESTIMATION_ORIGINAL_ESTIMATE;
	}

	if (typeof customFieldId === 'string' && customFieldId.startsWith('customfield_')) {
		// story points's customFieldId is customfield_<number>
		return ESTIMATION_STORY_POINTS;
	}

	// if it's something else, fallback to issue count
	// issue count's customFieldId is null
	return ESTIMATION_ISSUE_COUNT;
};
